export default {
    search_action_placeholder: "Buscar ação...",
    search_client_placeholder: "Buscar cliente...",
    search_placeholder: "Buscar...",
    close: "Fechar",
    cancel: "Cancelar",
    apply: "Aplicar",
    select: "Selecione",
    select_client: "Selecione o cliente",
    select_branches: "Selecione as filiais",
    client_no_registration: "Cliente sem cadastro",
    all: "Todos",
    enter_dates: "Informe as datas",
    enter_values: "Informe os valores",
    up_to: "Até {0}",
    after: "Depois de {0}",
    from: "A partir de {0}",
    between: "Entre {0} e {1}",
    not_informed: "Não informado",
    restrict_time_range: "Limitar intervalo de tempo",
    days_ago_title: "Dias atrás",
    period_days_ago: "Período: {0} dias atrás.",
    more_than: "Mais de {0}",
    date_picker: {
        days_of_week: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
            "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
            "Jul", "Ago", "Set", "Out", "Nov", "Dez",
        ],
    },
    ranges: {
        today: "Hoje",
        yesterday: "Ontem",
        this_month: "Esse mês",
        this_year: "Esse ano",
        last_month: "Mês passado",
        last_year: "Ano passado",
        all_period: "Todo o período",
    },
    last_12_months: "Últimos 12 meses",
    last_3_months: "Últimos 3 meses",
    last_x_days: "Últimos {0} dias",
    min: "Mínimo",
    max: "Máximo",
};
